import { useState, useEffect, useCallback } from "react"
import Autocomplete from '@mui/material/Autocomplete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import InputAdornment from '@mui/material/InputAdornment';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { Grid, TextField, Button, MenuItem } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import getDayjs from "../../../../context/DateInstance";
import { InputValidationMessage } from '../../../inputs/CustomField';
import { useAxios } from "../../../../context/AxiosHookContext";
import { useAuth } from "../../../../context/AuthContext";



export const TicketForm = ({ onClose, values }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [supportList, setSupportList] = useState([]);
    const [usersList, serUsersList] = useState([]);
    const [list, setList] = useState([]);
    const [ticket, setTicket] = useState(Object.keys(values).length > 0 ? values : { status: "Created",eventDate: getDayjs() });
    const axios = useAxios();
    const [filterName, setFilterName] = useState("");
    const [filterNameUsers, setFilterNameUsers] = useState("");
    const [openSupportList, setOpenSupportLis] = useState(false);
    const [openUserList, setOpenUserList] = useState(false);
    const [loading, setLoading] = useState(false)
    const { currentUser } = useAuth()
    const [filesList, setFileList] = useState([])

    const submitTicket = async () => {

        try {
            const formValid = checkMissingFields()

            if (formValid !== true) {
                return
            }

            if (currentUser.role.some(role => role === "Administrador") === false && Object.keys(values).length > 0 && currentUser._id !== values?.support_assigned?._id) {
                return
            }

            if (values.status === "Finished" && currentUser.role.some(role => role === "Administrador") === false) {
                return
            }


            setIsSubmitting(true);

            const valuesTransform = {
                support_type: ticket.support_type._id,
                support_subtype: ticket.support_subtype._id,
                support_subtype_1: ticket.support_subtype_1._id,
                status: ticket.status,
                requester: ticket.requester._id,
                support_assigned: ticket.support_assigned._id,
                eventDate: ticket.eventDate,
                ...(ticket.departmentShortName && { departmentShortName: ticket.departmentShortName }),
                ...(ticket.department && { department: ticket.department }),
            }

            if (ticket.support_created_by && ticket.support_created_by._id) {
                valuesTransform.support_created_by = ticket.support_created_by._id
            }

            if (ticket.comment) {
                valuesTransform.comment = ticket.comment
            }
            if (ticket.closed_comment) {
                valuesTransform.closed_comment = ticket.closed_comment
            }

            if (ticket.created_date) {
                valuesTransform.created_date = ticket.created_date
            }

            if (ticket.finished_date) {
                valuesTransform.finished_date = ticket.finished_date
            }



            if (ticket._id) {
                await axios.put(`/tickets/${ticket._id}`, valuesTransform)
            } else {

                await axios.post("/tickets", valuesTransform);
            }

            setIsSubmitting(false);
            onClose();

        } catch (error) {
            console.log(error)
            setIsSubmitting(false);
        }
    }

    const getTicketFiles = useCallback(async () => {
        try {
            const { data } = await axios.get(`/tickets/get_ticket_files/${ticket._id}`);
            setFileList(data.data)
        } catch (error) {
            console.log(error)
        }
    }, [axios, setFileList,ticket])


    

    const getSupports = useCallback(async () => {
        try {
            const dept = ticket?.departmentShortName || currentUser?.departmentShortName || ''
            const deptFilter = dept ? `&departmentShortName=${dept}` : ''
            const USERS_API = `/users?page=${1}&limit=30${filterName ? `&displayName=${filterName}` : ''}&role=${"Soporte"}${deptFilter}`
            setSupportList([])
            setLoading(true);
            const { data } = await axios.get(USERS_API);
            setSupportList(data.data.list);

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }, [axios, filterName, ticket?.departmentShortName, currentUser?.departmentShortName]);


    useEffect(() => {
        getSupports()
    }, [filterName])


    const checkMissingFields = () => {
        // Campos que se deben verificar en el objeto ticket

        if (!ticket.support_type || !ticket.support_type._id) {
            return "support_type"
        }

        if (!ticket.support_subtype || !ticket.support_subtype._id) {
            return "support_subtype"
        }

        if (!ticket.support_subtype_1 || !ticket.support_subtype_1._id) {
            return "support_subtype_1"
        }

        if (!ticket.requester || !ticket.requester._id) {
            return "requester"
        }

        if (!ticket.support_assigned || !ticket.support_assigned._id) {
            return "support_assigned"
        }

        return true
    }

    const getUsers = useCallback(async () => {
        try {
            const USERS_API = `/users?page=${1}&limit=30${filterNameUsers ? `&displayName=${filterNameUsers}` : ''}`
            serUsersList([])
            setLoading(true);
            const { data } = await axios.get(USERS_API);
            serUsersList(data.data.list);

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }, [axios, filterNameUsers, setLoading]);


    useEffect(() => {
        getUsers()
    }, [filterNameUsers])

    useEffect(() => {
        const categories = async () => {
            try {
                const types = JSON.stringify(["support_type", "support_subtype", "support_subtype_1"])
                const { data } = await axios.get(`/tickets/category?page=1&limit=50000&types=${types}&active=true`);
                setList(data.data.list)
            } catch (error) {
                console.log(error)
            }
        }

        if (ticket._id) {
            getTicketFiles();
        }

        categories()
    }, [])

    return (
        <>
            <Grid container spacing={2} >

                {
                    list.length > 0 &&

                    (
                        <>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <TextField size="small" name="support_type" label="Especifique el tipo" select fullWidth value={ticket?.support_type?._id || ""}
                                    onChange={(e) => {
                                        const item = list?.filter(item => item?.type === "support_type").filter(item1 => item1._id === e.target.value)
                                        setTicket({
                                            ...ticket,
                                            support_type: item[0],
                                            support_subtype: {},
                                            support_subtype_1: {}
                                        })
                                    }}
                                >
                                    {list?.filter(item => item?.type === "support_type")?.map((category) => (
                                        <MenuItem value={category._id} key={category._id} >{category.displayName}</MenuItem>
                                    ))}
                                </TextField>
                                {!ticket?.support_type?._id ? <InputValidationMessage message={"Es requerido este campo."} /> : ''}

                            </Grid>

                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <TextField size="small" name="support_subtype" label="Especifique el subtipo" select fullWidth value={ticket?.support_subtype?._id || ""}
                                    onChange={(e) => {
                                        const item = list?.filter(item => item?.type === "support_subtype").filter(item1 => item1._id === e.target.value)
                                        setTicket({
                                            ...ticket,
                                            support_subtype: item[0],
                                            support_subtype_1: {}
                                        })
                                    }}
                                >
                                    {list?.filter(item => item?.type === "support_subtype" && item.father === ticket?.support_type?._id)?.map((category) => (
                                        <MenuItem value={category._id} key={category._id} >{category.displayName}</MenuItem>
                                    ))}
                                </TextField>
                                {!ticket?.support_subtype?._id ? <InputValidationMessage message={"Es requerido este campo."} /> : ''}
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <TextField size="small" name="support_subtype_1" label="Especifique su necesidad" select fullWidth value={ticket?.support_subtype_1?._id || ""}
                                    onChange={(e) => {
                                        const item = list?.filter(item => item?.type === "support_subtype_1").filter(item1 => item1._id === e.target.value)
                                        setTicket({
                                            ...ticket,
                                            support_subtype_1: item[0]
                                        })
                                    }}
                                >
                                    {list?.filter(item => item?.type === "support_subtype_1" && item.father === ticket?.support_subtype?._id)?.map((category) => (
                                        <MenuItem value={category._id} key={category._id} >{category.displayName}</MenuItem>
                                    ))}
                                </TextField>
                                {!ticket?.support_subtype_1?._id ? <InputValidationMessage message={"Es requerido este campo."} /> : ''}
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <LocalizationProvider dateAdapter={AdapterDayjs} fullWidth>
                                    <DateTimePicker name="eventDate" label="Fecha del evento" fullWidth disabled={values?.status === "Finished"} 
                                        value={values?.created_date ? getDayjs(values?.eventDate || values?.created_date) : getDayjs()}
                                        onChange={(e) => {
                                            setTicket({
                                                ...ticket,
                                                eventDate: e
                                            })
                                        }}
                                        sx={{
                                            width: "100%",
                                            '& .MuiInputBase-input': {
                                                fontSize: '15px', // Ajusta el tamaño del texto
                                                padding: '8.5px 32px 8.5px 14px',
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <TextField size="small" name="status" select label="Estado" fullWidth value={ticket?.status}
                                    onChange={(e) => {
                                        setTicket({
                                            ...ticket,
                                            status: e.target.value
                                        })
                                    }}
                                >
                                    <MenuItem value="Created">Creado</MenuItem>
                                    <MenuItem value="Assigned">Asignado</MenuItem>
                                    <MenuItem value="Finished">Finalizado</MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} lg={6}>

                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    id="requester"
                                    open={openUserList}
                                    onOpen={() => {
                                        setOpenUserList(true);
                                    }}
                                    onClose={() => {
                                        setOpenUserList(false);
                                    }}
                                    isOptionEqualToValue={(option, value) => option._id === value._id}
                                    defaultValue={{ _id: ticket?.requester?._id || "", displayName: ticket?.requester?.displayName || "" }}
                                    getOptionLabel={(option) => option.displayName}
                                    options={usersList}
                                    loading={loading}
                                    onChange={(_e, value) => {

                                        setTicket({
                                            ...ticket,
                                            requester: value ? {
                                                _id: value._id,
                                                displayName: value.displayName
                                            } : value
                                        })
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            fullWidth
                                            size="small"
                                            {...params}
                                            label="Agregar solicitante"
                                            onChange={(e) => {
                                                setFilterNameUsers(e.target.value)
                                            }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                                {!ticket?.requester?._id ? <InputValidationMessage message={"Es requerido este campo."} /> : ''}
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12}>

                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    id="support_assigned"
                                    open={openSupportList}
                                    onOpen={() => {
                                        setOpenSupportLis(true);
                                    }}
                                    onClose={() => {
                                        setOpenSupportLis(false);
                                    }}
                                    isOptionEqualToValue={(option, value) => option.displayName === value.displayName}
                                    defaultValue={{ _id: ticket?.support_assigned?._id || "", displayName: ticket?.support_assigned?.displayName || "" }}
                                    getOptionLabel={(option) => option.displayName}
                                    options={supportList}
                                    loading={loading}
                                    onChange={(_e, value) => {
                                        setTicket({
                                            ...ticket,
                                            support_assigned: value ? {
                                                _id: value._id,
                                                displayName: value.displayName
                                            } : value,
                                            status: value ? "Assigned" : "Created"
                                        })
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            fullWidth
                                            size="small"
                                            {...params}
                                            label="Asignar soporte"
                                            onChange={(e) => {
                                                setFilterName(e.target.value)
                                            }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                                {!ticket?.support_assigned?._id ? <InputValidationMessage message={"Es requerido este campo."} /> : ''}
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <TextField name="comment" multiline rows={5} label="Por favor describa el inconveniente." fullWidth value={ticket?.comment || ""}

                                    onChange={(e) => {
                                        setTicket({
                                            ...ticket,
                                            comment: e.target.value
                                        })
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <TextField name="closed_comment" multiline rows={3} label="Comentario de finalización." fullWidth value={ticket?.closed_comment || ""}

                                    onChange={(e) => {
                                        setTicket({
                                            ...ticket,
                                            closed_comment: e.target.value
                                        })
                                    }}
                                />
                            </Grid>


                            <Grid item xs={12} sm={12} md={12} lg={12}>
                            {filesList?.map((file, key) => (
                                <TextField
                                    key={key}
                                    sx={{ margin: 0.3 }}
                                    fullWidth
                                    disabled
                                    value={file.file_name}
                                    InputProps={{
                                        style: { height: 40 },
                                        startAdornment: (
                                            <InputAdornment position="start" onClick={() => {
                                                window.open(process.env.REACT_APP_API_FULL_DOMAIN + file.file_api_path, '_blank')
                                            }} sx={{ cursor: "pointer" }} >
                                                <VisibilityIcon sx={{ fontSize: 40 }} />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            ))}
                        </Grid>

                            <Grid item sm={12} textAlign={"right"} mt={3}>

                                <Button
                                    variant="outlined"
                                    onClick={() => onClose()}
                                >
                                    cancelar
                                </Button>

                                <Button sx={{ marginLeft: 2 }}
                                    variant="contained"
                                    type="submit"
                                    onClick={() => {
                                        if (isSubmitting) {
                                            return
                                        }
                                        submitTicket()
                                    }}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting && <CircularProgress size={"15px"} sx={{ color: "white", marginRight: "6px" }} />}
                                    {isSubmitting ? 'Guardando' : 'Guardar'}
                                </Button>

                            </Grid>
                        </>
                    )
                }

            </Grid >
        </>
    );
}

export default TicketForm;